import { Controller } from "@hotwired/stimulus"

// Drives the dev-only YouTube deck editor: add / remove / reorder slides, cards, and
// beats in the DOM, then serialise the whole deck to JSON into a hidden field on
// submit. Reordering and nested cards/beats are awkward as flat Rails params, so the
// server receives one JSON payload and rebuilds the deck from it.
export default class extends Controller {
  static targets = ["slides", "input", "slideTemplate", "cardTemplate", "beatTemplate"]

  addSlide() {
    this.slidesTarget.appendChild(this.clone(this.slideTemplateTarget))
  }

  addCard(event) {
    this.container(event, "[data-cards]").appendChild(this.clone(this.cardTemplateTarget))
  }

  addBeat(event) {
    this.container(event, "[data-beats]").appendChild(this.clone(this.beatTemplateTarget))
  }

  remove(event) {
    event.target.closest("[data-movable]").remove()
  }

  moveUp(event) {
    const row = event.target.closest("[data-movable]")
    const prev = row.previousElementSibling
    if (prev?.matches("[data-movable]")) row.parentNode.insertBefore(row, prev)
  }

  moveDown(event) {
    const row = event.target.closest("[data-movable]")
    const next = row.nextElementSibling
    if (next?.matches("[data-movable]")) row.parentNode.insertBefore(next, row)
  }

  serialize() {
    const slides = [...this.slidesTarget.querySelectorAll(":scope > [data-deck-editor-target='slide']")].map((slide) => ({
      kind: this.value(slide, "kind"),
      eyebrow: this.value(slide, "eyebrow"),
      heading: this.value(slide, "heading"),
      body: this.value(slide, "body"),
      image: this.value(slide, "image"),
      cards: [...slide.querySelectorAll("[data-cards] [data-field='card']")].map((input) => input.value),
      beats: [...slide.querySelectorAll("[data-beats] [data-beat-row]")].map((row) => ({
        label: row.querySelector("[data-field='beat-label']").value,
        note: row.querySelector("[data-field='beat-note']").value,
      })),
    }))
    this.inputTarget.value = JSON.stringify(slides)
  }

  // The nearest ancestor slide's cards/beats container for an add button.
  container(event, selector) {
    return event.target.closest("[data-deck-editor-target='slide']").querySelector(selector)
  }

  clone(templateEl) {
    return templateEl.content.firstElementChild.cloneNode(true)
  }

  // A slide's own top-level field (cards/beats use distinct field names, so the
  // first match within the slide is always the slide-level input).
  value(slide, field) {
    return slide.querySelector(`[data-field='${field}']`)?.value ?? ""
  }
}
